import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch } from "react-redux";
import { CustomDatePick, getGraphList } from "../../../redux/action";
import moment from "moment";
import { styles } from "./Styles";

export default function CustomDatePicker({
  openDatePicker,
  openCSVWindow,
  setOpenCSVWindow,
  excelOption,
  setOpenDatePicker,
  name,
  activeValue,
}: any) {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleDateSelection = (start: Date | null, end: Date | null) => {
    if (!start || !end) {
      setStartDate(start);
      setEndDate(end);
      return;
    }

    setStartDate(start);
    setEndDate(end);
    setOpenDatePicker(false);
    if (excelOption) setOpenCSVWindow(false);

    if (excelOption) {
      const payload = {
        startDate: moment(start).format("DD/MM/YYYY"),
        endDate: moment(end).format("DD/MM/YYYY"),
        downloadReport: true,
      };
      dispatch(getGraphList(payload));
    } else {
      dispatch(CustomDatePick({ start, end, name }));
    }
  };

  const today = new Date();

  useEffect(() => {
    if (activeValue !== "custom") setOpenDatePicker(false);
    // eslint-disable-next-line
  }, [activeValue]);

  return (
    <>
     {((openDatePicker && activeValue === "custom") || openCSVWindow) && (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <Box sx={styles.customDatePicker}>
      <DatePicker
        label="Start Date"
        value={startDate}
        maxDate={today}
        format="dd/MM/yyyy"
        onChange={(date) => handleDateSelection(date, endDate)}
        slotProps={{ textField: { fullWidth: true } }}
      />
      <DatePicker
        label="End Date"
        value={endDate}
        maxDate={today}
        format="dd/MM/yyyy"
        onChange={(date) => handleDateSelection(startDate, date)}
        slotProps={{ textField: { fullWidth: true } }}
      />
    </Box>
  </LocalizationProvider>
)}

    </>
  );
}
